<template>
	<el-row>
		<el-row>
			<el-button @click="addLiCheng" type="infor">+添加里程主题</el-button>
		</el-row>
		<el-row>
			<el-calendar v-model="value">
				<template slot="dateCell" slot-scope="{ date, data }">
					<div @click="chooseDay(date, data)" style="width: 100%;height: 280px;">
						<div class="date">
							{{data.day}}
						</div>
						<div style="width: 100%;height: 50%;overflow:auto;">
							<div v-for="(item,index) in clrPlanTopic" :key="index">
								<div v-if="data.day>=item.beginTime2 && item.endTime2 >= data.day"
									:style="'background-color:'+(item.color)" style="width: 100%;height:45px;">
									<div v-if="item.beginTime2 == data.day"
										style="width: 100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
										<span>节日主题：<span>{{item.topic}}</span></span></br>
										<span>
											内容要点：<span>{{item.context}}</span>
										</span>
									</div>
									<div v-if="item.endTime2 == data.day">
										<el-button icon="el-icon-delete" type="text" @click="delPlanTopic(item,index)"
											style="color: red;">
										</el-button>
										<el-button icon="el-icon-edit-outline" type="text"
											@click="editorPlanTopic(item,index)"></el-button>
									</div>
								</div>
							</div>
						</div>
						<div style="width: 100%;height: 35%;overflow:auto;">
							<div v-for="(item2,index2) in clrPlanContent" :key="index2">
								<div v-if="item2.belongTime == data.day"
									style="display: flex;width: 100%;height: 30px;align-items: center;">
									<div style="width: 70%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
										<span>{{item2.name}}:{{item2.typeName}}</span>
									</div>
									<div style="width: 30%;">
										<el-button icon="el-icon-delete" type="text"
											@click="delclrPlanContent(item2,index2)" style="color: red;" size="mini">
										</el-button>
										<el-button icon="el-icon-edit-outline" type="text"
											@click="editorclrPlanContent(item2,index2)" size="mini"></el-button>
									</div>
								</div>
							</div>
						</div>
						<div style="width: 100%;height: 20px;text-align: center;" v-if="data.isSelected && isShow[0]">
							<el-button @click.stop="addType(data)" size="mini">+添加当日计划</el-button>
						</div>
					</div>
				</template>
			</el-calendar>
		</el-row>
		<el-dialog :visible.sync="dialogVisible" :title="title" center width="40%">
			<el-form :model="info" ref="info" label-width="100px" label-position="right">
				<el-form-item label="里程碑时间:" :rules="[{
					   required: true,message: '请输入里程碑时间', trigger: 'blur' 
				}]">
					<el-date-picker v-model="info.beginTime" type="datetime" placeholder="开始时间" default-time="00:00:00"
						value-format="yyyy-MM-dd HH:mm:ss">
					</el-date-picker>
					<span>~</span>
					<el-date-picker v-model="info.endTime" type="datetime" placeholder="结束时间" default-time="23:59:59"
						value-format="yyyy-MM-dd HH:mm:ss">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="里程碑颜色:" prop="color" :rules="[{
					   required: true, message: '请选择里程碑颜色', trigger: 'blur' 
				}]">
					<el-color-picker v-model="info.color" show-alpha></el-color-picker>

				</el-form-item>
				<el-form-item label="节点主题:" prop="topic" :rules="[{
					   required: true, message: '请输入节点主题', trigger: 'blur' 
				}]">
					<el-input v-model="info.topic" style="width: 400px;" show-alpha="true"></el-input>
				</el-form-item>
				<el-form-item label="内容要点:" prop="context" :rules="[{
					   required: true, message: '内容要点', trigger: 'blur' 
				}]">
					<el-input v-model="info.context" type="textarea" style="width: 400px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="dialogVisible = false" type="infor">取消</el-button>
					<el-button @click="submit" type="primary">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisible2" :title="title" center width="40%">
			<el-form :model="info2" ref="info2" label-width="100px" label-position="right">
				<el-form-item label="计划类型">
					<el-select v-model="info2.type" filterable @change="chooseType">
						<el-option v-for="(item,index) in options" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="课程名称:" v-if="info2.type == 0">
					<el-select v-model="info2.type2" filterable value-key="value">
						<el-option v-for="(item,index) in kcoptions" :key="item.value" :label="item.label"
							:value="item"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="商品名称/id:" v-if="info2.type == 1">
					<el-input v-model="query.id" clearable placeholder="商品id" style="width: 150px;"></el-input>
					<el-input v-model="query.name" clearable placeholder="商品名称" style="width: 150px;margin: 0 20px;">
					</el-input>
					<el-button @click="chaxun()">查询</el-button>
					<el-select v-model="info2.type2" filterable style="margin-top: 10px;">
						<el-option v-for="(item,type2) in spoptions" :key="item.value" :label="item.label"
							:value="item"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="活动sop" v-if="info2.type == 2">
					<el-select v-model="info2.type2" filterable>
						<el-option v-for="(item,index) in sooptions" :key="item.value" :label="item.label"
							:value="item"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="训练营" v-if="info2.type == 3">
					<el-select v-model="info2.type2" filterable placeholder="请输入训练营名称">
						<el-option v-for="(item,index) in caoptions" :key="item.value" :label="item.label"
							:value="item"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button @click="dialogVisible2 = false" type="infor">取消</el-button>
					<el-button @click="submit2" type="primary">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>

<script>
	import http from '../../util/request.js'
	export default {
		data() {
			return {
				value: new Date(),
				dialogVisible: false,
				dialogVisible2: false,
				isShow: [false, false, false],
				title: '',
				clrPlanTopic: [], //里程碑
				clrPlanContent: [], //计划
				info: {
					id: '',
					beginTime: '',
					endTime: '',
					topic: '',
					context: '',
					color: ''
				},
				info2: {
					type: 0,
					type2: {},
					belongTime: '',
					id: '',
				},
				query: {
					name: '',
					id: '',
				},
				kcoptions: [], //课程集合
				spoptions: [], //商品集合
				sooptions: [], //活动集合
				caoptions: [], //训练营集合
				options: [{
						value: 0,
						label: '当日学习'
					},
					{
						value: 1,
						label: '主推商品'
					},
					{
						value: 2,
						label: '主推活动'
					},
					{
						value: 3,
						label: '训练营'
					}
				]
			};
		},
		methods: {
			//选择某一天
			chooseDay(date, data) {
				if (data.isSelected) {
					this.isShow = [true, false, false]
				}
			},
			addType(data) {
				this.dialogVisible2 = true
				// this.info2.belongTime = data.day
				this.title = "添加计划"
				this.info2 = {
					type: '',
					id: '',
					type2: {},
					belongTime: data.day
				}
				this.query = {
					name: '',
					id: '',
				}
				this.kcoptions = []
				this.spoptions = []
				this.sooptions = []
				this.caoptions = []
				console.log(this.info2);
			},
			chooseType() {
				this.info2.type2 = {}
				switch (this.info2.type) {
					case 0: {
						this.kcoptions = []
						this.getKeCheng()
						break;
					}
					case 1: {
						break;
					}
					case 2: {

						break;
					}
					case 3: {
						this.caoptions = []
						this.getCamp()
						break;
					}
				}
			},
			//打开添加里程碑
			addLiCheng() {
				this.dialogVisible = true
				this.title = '添加里程碑主题'
				this.info = {
					id: '',
					beginTime: '',
					endTime: '',
					topic: '',
					context: '',
					color: ''
				}
			},
			//提交里程碑
			submit() {
				console.log(this.info);
				if (this.info.beginTime == '' || this.info.endTime == '') {
					this.$message.error('请选择时间')
					return false
				}
				this.$refs.info.validate(vai => {
					if (vai) {
						if (this.title == '添加里程碑主题') {
							this.$http.post('/api/course/clrPlanTopic/add', this.info).then(res => {
								console.log(res);
								if (res.data.status == 0) {
									this.$message.success('添加里程碑成功')
									this.dialogVisible = false
									this.getInfo()
									this.getInfo2()
								} else {
									this.$message.error(res.data.msg)
								}
							}).catch((error) => {
								this.$message.error("发生了一些错误:" + error);
							})
						} else if (this.title == '编辑里程碑主题') {
							this.$http.post('/api/course/clrPlanTopic/update', this.info).then(res => {
								if (res.data.status == 0) {
									this.$message.success('更新里程碑成功')
									this.dialogVisible = false
									this.getInfo()
									this.getInfo2()
								} else {
									this.$message.error(res.data.msg)
								}
							}).catch((error) => {
								this.$message.error("发生了一些错误:" + error);
							})
						}
					}
				})
			},
			//提交计划
			submit2() {
				console.log(this.info2);
				// return false
				this.$refs.info2.validate(vai => {
					if (vai) {
						if (this.title == '添加计划') {
							this.$http.post('/api/course/clrPlanContent/add', {
								type: this.info2.type,
								typeId: this.info2.type2.value,
								typeName: this.info2.type2.label,
								belongTime: this.info2.belongTime
							}).then(res => {
								console.log(res);
								if (res.data.status == 0) {
									this.$message.success('添加计划成功')
									this.dialogVisible2 = false
									this.getInfo()
									this.getInfo2()
								} else {
									this.$message.error('添加计划失败')
								}
							}).catch((error) => {
								this.$message.error("发生了一些错误:" + error);
							})
						} else {
							this.$http.post('/api/course/clrPlanContent/update', {
								id: this.info2.id,
								type: this.info2.type,
								typeId: this.info2.type2.value,
								typeName: this.info2.type2.label,
								belongTime: this.info2.belongTime
							}).then(res => {
								console.log(res);
								if (res.data.status == 0) {
									this.$message.success('更新计划成功')
									this.dialogVisible2 = false
									this.getInfo()
									this.getInfo2()
								} else {
									this.$message.error('更新计划失败')
								}
							}).catch((error) => {
								this.$message.error("发生了一些错误:" + error);
							})
						}
					}
				})
			},
			//删除里程碑
			delPlanTopic(item) {
				this.$confirm('此操作将永久删除该里程碑, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post('/api/course//clrPlanTopic/delete', {
						id: item.id
					}).then(res => {
						if (res.data.status == 0) {
							this.getInfo()
							this.getInfo2()
						} else {
							this.$message.error(res.data.msg)
						}
					}).catch((error) => {
						this.$message.info(error);
					});
				}).catch(() => {
					this.$message.info('已取消删除');
				});
			},
			//编辑里程碑
			editorPlanTopic(item) {
				console.log(item);
				this.dialogVisible = true
				this.title = '编辑里程碑主题'
				this.info = {
					id: item.id,
					topic: item.topic,
					context: item.context,
					color: item.color,
					beginTime: item.beginTime,
					endTime: item.endTime
				}
			},
			//删除计划
			delclrPlanContent(item) {
				this.$confirm('此操作将永久删除该计划, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post('/api/course//clrPlanContent/delete', {
						id: item.id
					}).then(res => {
						if (res.data.status == 0) {
							this.$message.success(res.data.msg)
							this.getInfo()
							this.getInfo2()
						} else {
							this.$message.error(res.data.msg)
						}
					}).catch((error) => {
						this.$message.info(error);
					});
				}).catch(() => {
					this.$message.info('已取消删除');
				});
			},
			//编辑计划
			editorclrPlanContent(item) {
				console.log(item);
				this.dialogVisible2 = true
				this.title = '编辑计划'
				this.info2 = {
					type: item.type, //计划类型 0 ：学习，1 商品 ，2 活动
					type2: {
						value: item.typeId,
						label: item.typeName
					},
					id: item.id,
					belongTime: item.belongTime
				}
				if (item.type == 1) {
					// this.query = {
					// 	id: item.typeId,
					// 	name: item.typeName
					// }
					this.getShangpin(item.typeName, item.typeId)
				}
			},
			//查询里程碑
			getInfo() {

				// this.$http.post('/api/course/clrPlanTopic/select', {
				// 	beginTime: this.getFirstDay(),
				// 	endTime: this.getLastDay()
				// }).then(res => {
				// 	console.log('里程碑', res.data.data);
				// 	if (res.data.data.length > 0) {
				// 		res.data.data.forEach(i => {
				// 			i.beginTime2 = i.beginTime.slice(0, 10)
				// 			i.endTime2 = i.endTime.slice(0, 10)
				// 		})
				// 	}
				// 	this.clrPlanTopic = res.data.data
				// }).catch((error) => {
				// 	this.$message.error("发生了一些错误:" + error);
				// })
			},
			//查询计划
			getInfo2() {
				this.$http.post('/api/course/clrPlanContent/select', {
					planTopicId: "",
					type: "",
					typeId: "",
					typeName: "",
					belongTime: ""
				}).then(res => {
					console.log('计划', res.data);
					if (res.data.length > 0) {
						res.data.forEach(i => {
							if (i.type == 0) {
								i.name = '学习'
							}
							if (i.type == 1) {
								i.name = '商品'
							}
							if (i.type == 2) {
								i.name = '活动'
							}
							if (i.type == 3) {
								i.name = '训练'
							}
						})
					}
					this.clrPlanContent = res.data
				}).catch((error) => {
					this.$message.error("发生了一些错误:" + error);
				})
			},
			//课程
			getKeCheng() {
				this.$http.post('/api/course/clrCourse/selectCourseList', {}).then(res => {
					if (res.data.data.length > 0) {
						res.data.data.forEach(i => {
							this.kcoptions.push({
								label: i.courseName,
								value: i.courseId
							})
						})
					}
				}).catch((error) => {
					this.$message.error("发生了一些错误:" + error);
				})
			},
			//训练营
			getCamp() {
				this.$http.post(
					`/api/plant/positions/selectCamp`, {}
				).then(res => {
					console.log(res.data.data);
					if (res.data.data.length > 0) {
						res.data.data.forEach(i => {
							this.caoptions.push({
								label: i.scenario_name,
								value: i.id
							})
						})
					}
				}).catch((error) => {
					this.$message.error("发生了一些错误:" + error);
				})
			},
			//查询
			chaxun() {
				if (this.query.id == '' && this.query.name == '') {
					this.$message.error("请输入商品名称/ID");
				} else {
					this.info2.type2 = {}
					this.getShangpin(this.query.name, this.query.id)
				}
			},
			getShangpin(name, id) {
				this.$http.post(
					`/api/course/clrCourse/selectProductName?productName=${name}&id=${id}`, {}
				).then(res => {
					console.log(res.data.data);
					this.spoptions = []
					if (res.data.data.length > 0) {
						res.data.data.forEach(i => {
							this.spoptions.push({
								value: i.id,
								label: i.name
							})
						})
					} else {
						this.$message.error('未找到商品')
					}
				}).catch((error) => {
					this.$message.error("发生了一些错误:" + error);
				})
			},
			getFirstDay() { //当前月第一天
				let date = this.value
				var y = date.getFullYear(); //获取年份
				var m = date.getMonth() + 1; //获取月份
				var d = '01';
				var t = ' 00:00:00'
				m = m < 10 ? '0' + m : m; //月份补 0
				return [y, m, d].join("-") + t
			},
			getLastDay() { //当前月最后一天
				let date = this.value
				var y = date.getFullYear(); //获取年份
				var m = date.getMonth() + 1; //获取月份
				var d = new Date(y, m, 0).getDate(); //获取当月最后一日
				m = m < 10 ? '0' + m : m; //月份补 0
				d = d < 10 ? '0' + d : d; //日数补 0
				var t = ' 23:59:59'
				console.log([y, m, d].join("-") + t);
				return [y, m, d].join("-") + t
			}
		},
		created() {
			console.log(http.prefix);
			this.getInfo()
			this.getInfo2()
			this.getKeCheng()
			this.getCamp()
			this.$nextTick(() => {
				// 点击上个月
				let prevBtn1 = document.querySelector(
					'.el-calendar__button-group .el-button-group>button:nth-child(1)');
				prevBtn1.addEventListener('click', () => {
					this.getInfo()
					this.getInfo2()
				})
				// 点击今天
				let prevBtn2 = document.querySelector(
					'.el-calendar__button-group .el-button-group>button:nth-child(2)');
				prevBtn2.addEventListener('click', () => {
					this.getInfo()
					this.getInfo2()
				})
				// 点击下个月
				let prevBtn3 = document.querySelector(
					'.el-calendar__button-group .el-button-group>button:nth-child(3)');
				prevBtn3.addEventListener('click', () => {
					this.getInfo()
					this.getInfo2()
				})
			})
		},
	};
</script>

<style scoped>
	div/deep/ .el-calendar-table .el-calendar-day {
		height: 300px;
		width: auto;
	}

	div/deep/ .el-calendar-table thead th {
		padding: 12px 100px;
	}

	.date {
		width: 100%;
		height: 20px;
		text-align: center;
		line-height: 20px
	}
</style>>
